import { useStores } from '@/stores';
import { useState, useRef, useCallback } from 'react';
import { observer } from 'mobx-react';
import { useOnClickOutside } from '@/hooks/useOnClickOutSide';
import { COUNTRIES, Country } from '@/mock/Country';
import clsx from 'clsx';

const CountryCombobox = observer((): JSX.Element => {
  const { userStore } = useStores();
  const [visible, setVisible] = useState<boolean>(false);
  const [selectedCountry, setSelectedCountry] = useState<Country>(COUNTRIES[0]);
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setVisible(false));

  const onChangeCountry = useCallback(
    (country: Country) => {
      userStore.setCountry(country.dialCode);
      setSelectedCountry(country);
      setVisible(!visible);
    },
    [userStore, visible],
  );

  const onClick = useCallback(() => setVisible(!visible), [visible]);

  return (
    <div className="dropdown-container-join-sms-2" ref={ref}>
      <div className="dropdown-header" onClick={onClick} role="button" id="dropdownHeader">
        <div className="dropdown-left">
          <div className="dropdown-img">
            <img src={selectedCountry.flagImg} alt={`${selectedCountry.name} Flag`} />
          </div>
          <span className="body-n-n d-gray">
            {selectedCountry.name} {selectedCountry.dialCode}
          </span>
        </div>
        <div className="dropdown-right">
          <i className={clsx('bi', visible ? 'bi-chevron-up' : 'bi-chevron-down', 'dropdown-icon')}></i>
        </div>
      </div>
      {visible && (
        <ul style={{ display: visible ? 'block' : 'none' }} className="dropdown-list" id="dropdownList">
          {COUNTRIES.filter((country) => country.code !== selectedCountry.code).map((country) => (
            <li key={country.code} className="dropdown-item" onClick={() => onChangeCountry(country)}>
              <div className="dropdown-img">
                <img src={country.flagImg} alt={`${country.name} Flag`} />
              </div>
              <span className="body-n-n">
                {country.name} {country.dialCode}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

export default CountryCombobox;
